module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "goods-info"
  }, [_c('div', {
    staticClass: "tableConBox"
  }, [_c('div', {
    staticClass: "tableTem"
  }, [_c('div', {
    staticClass: "HSpace1"
  }), _vm._v(" "), _c('div', {
    staticClass: "searchBox flex flex-align-center"
  }, [_c('div', {
    staticClass: "searchCon clearfix"
  }, [_c('div', {
    staticClass: "left search flex flex-align-center",
    staticStyle: {
      "width": "120px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.goods),
      expression: "goods"
    }],
    staticClass: "left",
    attrs: {
      "type": "text",
      "placeholder": "请输入商品名"
    },
    domProps: {
      "value": (_vm.goods)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.goods = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-search",
    on: {
      "click": _vm.searchGoods
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "details_search",
    style: ({
      display: (_vm.goodCheckArr[0] ? 'block' : 'none')
    }),
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "leftIcon",
    style: ({
      top: (_vm.curGoodIdx * 40 + 'px')
    })
  }, [_c('div', {
    staticClass: "iconInner"
  })]), _vm._v(" "), _vm._l((_vm.goodCheckArr), function(item) {
    return _c('li', {
      on: {
        "click": function($event) {
          return _vm.selSearchGood(item, 'search')
        }
      }
    }, [_c('div', {
      staticClass: "left name ellipsis",
      attrs: {
        "title": item.name
      },
      domProps: {
        "textContent": _vm._s(item.name)
      }
    })])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "fliter type"
  }, [_vm._v("\n                        分类选择：\n                        "), _c('el-select', {
    staticStyle: {
      "width": "120px"
    },
    model: {
      value: (_vm.fliter_type),
      callback: function($$v) {
        _vm.fliter_type = $$v
      },
      expression: "fliter_type"
    }
  }, [_c('el-option', {
    key: "",
    attrs: {
      "label": "全部",
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.systemData), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), _vm._v(" "), _vm._l((_vm.typeList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  })], 2)], 1), _vm._v(" "), _c('span', {
    staticClass: "fliter"
  }, [_vm._v("\n                        管理库存：\n                        "), _c('el-select', {
    model: {
      value: (_vm.fliter_stock),
      callback: function($$v) {
        _vm.fliter_stock = $$v
      },
      expression: "fliter_stock"
    }
  }, [_c('el-option', {
    key: "",
    attrs: {
      "label": "全部",
      "value": ""
    }
  }), _vm._v(" "), _c('el-option', {
    key: "true",
    attrs: {
      "label": "是",
      "value": "true"
    }
  }), _vm._v(" "), _c('el-option', {
    key: "false",
    attrs: {
      "label": "否",
      "value": "false"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "fliter"
  }, [_vm._v("\n                        厨房打印：\n                        "), _c('el-select', {
    model: {
      value: (_vm.fliter_kitchen),
      callback: function($$v) {
        _vm.fliter_kitchen = $$v
      },
      expression: "fliter_kitchen"
    }
  }, [_c('el-option', {
    key: "",
    attrs: {
      "label": "全部",
      "value": ""
    }
  }), _vm._v(" "), _c('el-option', {
    key: "true",
    attrs: {
      "label": "是",
      "value": "true"
    }
  }), _vm._v(" "), _c('el-option', {
    key: "false",
    attrs: {
      "label": "否",
      "value": "false"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "left searchBtn",
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_c('button', {
    staticStyle: {
      "padding": "0 10px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.fliterGoods
    }
  }, [_vm._v("筛选")])]), _vm._v(" "), _c('div', {
    staticClass: "right searchBtn"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addGoods
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v("添加商品")])])])]), _vm._v(" "), _c('div', {
    staticClass: "HSpace2"
  }), _vm._v(" "), _c('div', {
    staticClass: "tableBox"
  }, [_c('div', {
    staticClass: "tableBoxScroll"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('table', {
    staticClass: "conTable",
    class: {
      overLengthTable: _vm.vipData.length > 6
    }
  }, _vm._l((_vm.vipData), function(item, idx) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "4%"
      },
      domProps: {
        "textContent": _vm._s(item.id ? (idx + 1) : '')
      }
    }), _vm._v(" "), _c('td', {
      staticClass: "img",
      staticStyle: {
        "width": "8%"
      }
    }, [(item.id) ? _c('div', {
      staticClass: "img_box"
    }, [_c('img', {
      attrs: {
        "src": item.imageURL + '?x-oss-process=image/resize,l_300',
        "alt": ""
      }
    })]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      },
      attrs: {
        "title": item.name
      },
      domProps: {
        "textContent": _vm._s(item.name)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "8%"
      },
      domProps: {
        "textContent": _vm._s(item.typeName)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "5%"
      },
      domProps: {
        "textContent": _vm._s(item.sort)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "6%"
      },
      domProps: {
        "textContent": _vm._s(item.salesPrice)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "11%"
      }
    }, [(item.id && item.supplyTimes && JSON.parse(item.supplyTimes).length) ? _c('span', _vm._l((JSON.parse(item.supplyTimes)), function(oitem) {
      return _c('span', {
        domProps: {
          "textContent": _vm._s((oitem.beginHour < 10 ? '0' + oitem.beginHour : oitem.beginHour) + ':' +
            (oitem.beginMinute < 10 ? '0' + oitem.beginMinute : oitem.beginMinute) + '~' +
            (oitem.endHour < 10 ? '0' + oitem.endHour : oitem.endHour) + ':' +
            (oitem.endMinute < 10 ? '0' + oitem.endMinute : oitem.endMinute) + ',')
        }
      })
    }), 0) : _vm._e(), _vm._v(" "), ((item.id && !item.supplyTimes) || item.supplyTimes == '[]') ? _c('span', [_vm._v("全天")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "11%"
      }
    }, [(item.id && item.disShow) ? _c('span', [_c('span', [_vm._v(_vm._s(item.nowHours + '~' + item.tomorrowHour))])]) : _vm._e(), _vm._v(" "), ((item.id && !item.disShow)) ? _c('span', [_vm._v("暂无")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "6%"
      }
    }, [(item.id) ? _c('span', {
      staticClass: "goods_status_on",
      class: {
        goods_status_off: !item.memberShow
      },
      domProps: {
        "textContent": _vm._s(item.memberShow ? '是' : '否')
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "4%"
      }
    }, [(item.id) ? _c('span', {
      staticClass: "goods_status_on",
      class: {
        goods_status_off: !item.disShow
      },
      domProps: {
        "textContent": _vm._s(item.disShow ? '是' : '否')
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "5%"
      }
    }, [(item.id) ? _c('span', {
      staticClass: "goods_status_on",
      class: {
        goods_status_off: !item.kitchenPrintEnabled
      },
      domProps: {
        "textContent": _vm._s(item.kitchenPrintEnabled ? '是' : '否')
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "5%"
      }
    }, [(item.id) ? _c('span', {
      staticClass: "goods_status_on",
      class: {
        goods_status_off: !item.labelEnabled
      },
      domProps: {
        "textContent": _vm._s(item.labelEnabled ? '是' : '否')
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "5%"
      }
    }, [(item.id) ? _c('span', {
      staticClass: "goods_status_on",
      class: {
        goods_status_off: !item.stockEnabled
      },
      domProps: {
        "textContent": _vm._s(item.stockEnabled ? '是' : '否')
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "12%"
      }
    }, [(item.id) ? _c('div', {
      staticClass: "btnInline"
    }, [_c('el-button', {
      attrs: {
        "type": "text",
        "title": "修改"
      },
      on: {
        "click": function($event) {
          return _vm.uploadGood(item)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-bianji"
    })]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "text",
        "title": "删除"
      },
      on: {
        "click": function($event) {
          return _vm.delGoods(item.id)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-icon1460188478041"
    })])], 1) : _vm._e()])])
  }), 0)])])])])])]), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.infoload),
      expression: "infoload",
      modifiers: {
        "body": true
      }
    }],
    attrs: {
      "title": _vm.btnId ? '修改商品' : '添加商品',
      "visible": _vm.dialogVisible,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', [_c('div', {
    staticClass: "msgBox clearfix",
    on: {
      "click": _vm.hideSearchList
    }
  }, [_c('div', {
    staticClass: "left msgItem clearfix searchbox"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("商品名")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newGoods.name),
      expression: "newGoods.name"
    }],
    staticClass: "left itemInput",
    attrs: {
      "type": "text",
      "placeholder": "请输入商品名"
    },
    domProps: {
      "value": (_vm.newGoods.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newGoods, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "details_search add_details_search",
    style: ({
      display: (_vm.addGoodCheckArr[0] ? 'block' : 'none')
    }),
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "leftIcon",
    style: ({
      top: (_vm.addCurGoodIdx * 40 + 'px')
    })
  }, [_c('div', {
    staticClass: "iconInner"
  })]), _vm._v(" "), _vm._l((_vm.addGoodCheckArr), function(item) {
    return _c('li', {
      on: {
        "click": function($event) {
          return _vm.selSearchGood(item, 'add')
        }
      }
    }, [_c('div', {
      staticClass: "left name ellipsis",
      attrs: {
        "title": item.name
      },
      domProps: {
        "textContent": _vm._s(item.name)
      }
    })])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix searchbox"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_vm._v("商品描述")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newGoods.note),
      expression: "newGoods.note"
    }],
    staticClass: "left itemInput",
    attrs: {
      "type": "text",
      "placeholder": "请输入商品描述"
    },
    domProps: {
      "value": (_vm.newGoods.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newGoods, "note", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("商品分类")]), _vm._v(" "), _c('el-select', {
    staticClass: "itemSelect",
    staticStyle: {
      "width": "40%"
    },
    attrs: {
      "placeholder": "请选择商品分类"
    },
    model: {
      value: (_vm.newGoods.productTypeId),
      callback: function($$v) {
        _vm.$set(_vm.newGoods, "productTypeId", $$v)
      },
      expression: "newGoods.productTypeId"
    }
  }, [_vm._l((_vm.systemData), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), _vm._v(" "), _vm._l((_vm.typeList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("数量/价格")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newGoods.productQty),
      expression: "newGoods.productQty"
    }],
    staticClass: "left itemInput",
    staticStyle: {
      "width": "50px",
      "text-align": "center"
    },
    attrs: {
      "type": "text",
      "placeholder": "数量"
    },
    domProps: {
      "value": (_vm.newGoods.productQty)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newGoods, "productQty", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "left"
  }, [_vm._v("个")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newGoods.salesPrice),
      expression: "newGoods.salesPrice"
    }],
    staticClass: "left itemInput",
    staticStyle: {
      "width": "50px",
      "text-align": "center"
    },
    attrs: {
      "type": "text",
      "placeholder": "价格"
    },
    domProps: {
      "value": (_vm.newGoods.salesPrice)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newGoods, "salesPrice", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "left"
  }, [_vm._v("元")])]), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("商品排序")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newGoods.sort),
      expression: "newGoods.sort"
    }],
    staticClass: "left itemInput",
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "type": "text",
      "placeholder": "",
      "maxlength": "6"
    },
    domProps: {
      "value": (_vm.newGoods.sort)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newGoods, "sort", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("管理库存")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": "ON"
    },
    model: {
      value: (_vm.isStock),
      callback: function($$v) {
        _vm.isStock = $$v
      },
      expression: "isStock"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": "OFF"
    },
    model: {
      value: (_vm.isStock),
      callback: function($$v) {
        _vm.isStock = $$v
      },
      expression: "isStock"
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), (_vm.isStock == 'ON') ? _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("库存告警值")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newGoods.threshold),
      expression: "newGoods.threshold"
    }],
    staticClass: "left itemInput",
    staticStyle: {
      "width": "100px",
      "text-align": "center"
    },
    attrs: {
      "type": "text",
      "placeholder": "数量"
    },
    domProps: {
      "value": (_vm.newGoods.threshold)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newGoods, "threshold", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("厨房打印")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": "ON"
    },
    model: {
      value: (_vm.kitchenPrintEnabled),
      callback: function($$v) {
        _vm.kitchenPrintEnabled = $$v
      },
      expression: "kitchenPrintEnabled"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": "OFF"
    },
    model: {
      value: (_vm.kitchenPrintEnabled),
      callback: function($$v) {
        _vm.kitchenPrintEnabled = $$v
      },
      expression: "kitchenPrintEnabled"
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), (_vm.kitchenPrintEnabled == 'ON') ? _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("打印机")]), _vm._v(" "), _c('el-select', {
    staticClass: "itemSelect",
    staticStyle: {
      "width": "40%"
    },
    attrs: {
      "placeholder": "请选择打印机"
    },
    model: {
      value: (_vm.newGoods.ipId),
      callback: function($$v) {
        _vm.$set(_vm.newGoods, "ipId", $$v)
      },
      expression: "newGoods.ipId"
    }
  }, [_c('el-option', {
    key: -1,
    attrs: {
      "label": '无',
      "value": ''
    }
  }), _vm._v(" "), _vm._l((_vm.printEr), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  })], 2)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("标签打印")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": 1
    },
    model: {
      value: (_vm.newGoods.labelEnabled),
      callback: function($$v) {
        _vm.$set(_vm.newGoods, "labelEnabled", $$v)
      },
      expression: "newGoods.labelEnabled"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": 0
    },
    model: {
      value: (_vm.newGoods.labelEnabled),
      callback: function($$v) {
        _vm.$set(_vm.newGoods, "labelEnabled", $$v)
      },
      expression: "newGoods.labelEnabled"
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("岗位提成\n                         "), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "开启岗位提成后，固定提成、时间段提成无效。",
      "placement": "top"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-wenhao-yuankuang"
  })])], 1), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": true
    },
    model: {
      value: (_vm.newGoods.postEnabled),
      callback: function($$v) {
        _vm.$set(_vm.newGoods, "postEnabled", $$v)
      },
      expression: "newGoods.postEnabled"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": false
    },
    model: {
      value: (_vm.newGoods.postEnabled),
      callback: function($$v) {
        _vm.$set(_vm.newGoods, "postEnabled", $$v)
      },
      expression: "newGoods.postEnabled"
    }
  }, [_vm._v("否")]), _vm._v(" "), (_vm.newGoods.postEnabled == true) ? _c('span', {
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "right": "30px",
      "cursor": "pointer",
      "color": "red"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.addCommJob.apply(null, arguments)
      }
    }
  }, [_vm._v("添加")]) : _vm._e()], 1), _vm._v(" "), (_vm.newGoods.postEnabled == false) ? [_c('div', {
    staticClass: "left msgItem clearfix",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("时段提成\n                            "), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "开启时段提成后，岗位提成、固定提成无效。",
      "placement": "top"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-wenhao-yuankuang"
  })])], 1), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": true
    },
    model: {
      value: (_vm.newGoods.timeRangeComm),
      callback: function($$v) {
        _vm.$set(_vm.newGoods, "timeRangeComm", $$v)
      },
      expression: "newGoods.timeRangeComm"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": false
    },
    model: {
      value: (_vm.newGoods.timeRangeComm),
      callback: function($$v) {
        _vm.$set(_vm.newGoods, "timeRangeComm", $$v)
      },
      expression: "newGoods.timeRangeComm"
    }
  }, [_vm._v("否")]), _vm._v(" "), (_vm.newGoods.timeRangeComm == true) ? _c('span', {
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "right": "30px",
      "cursor": "pointer",
      "color": "red"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.addCommTime.apply(null, arguments)
      }
    }
  }, [_vm._v("添加")]) : _vm._e()], 1), _vm._v(" "), (_vm.newGoods.timeRangeComm == false) ? _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("商品提成")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newGoods.commission),
      expression: "newGoods.commission"
    }],
    staticClass: "left itemInput",
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入提成",
      "maxlength": "6"
    },
    domProps: {
      "value": (_vm.newGoods.commission)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newGoods, "commission", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "left",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("元")])]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.newGoods.timeRangeComm == true && _vm.newGoods.postEnabled == false) ? _vm._l((_vm.newTimeListForComm), function(timeItem, timeIndex) {
    return _c('div', {
      key: timeIndex
    }, [_c('div', {
      staticClass: "left msgItem clearfix",
      staticStyle: {
        "position": "relative"
      }
    }, [_c('span', {
      staticClass: "left itemName"
    }, [_c('i', [_vm._v("*")]), _vm._v("商品提成")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (timeItem.commission),
        expression: "timeItem.commission"
      }],
      staticClass: "left itemInput",
      staticStyle: {
        "width": "30%"
      },
      attrs: {
        "type": "text",
        "placeholder": "请输入提成",
        "maxlength": "6"
      },
      domProps: {
        "value": (timeItem.commission)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(timeItem, "commission", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "left",
      staticStyle: {
        "width": "30%"
      }
    }, [_vm._v("元")])]), _vm._v(" "), _c('div', {
      staticClass: "left msgItem clearfix saleTimes",
      staticStyle: {
        "display": "flex"
      }
    }, [_c('span', {
      staticClass: "left itemName"
    }, [_vm._v("提成时间段")]), _vm._v(" "), _c('div', {
      staticClass: "left timesBox clearfix"
    }, [_c('span', {
      staticClass: "itemSelect left"
    }, [_c('el-time-picker', {
      attrs: {
        "is-range": "",
        "format": "HH:mm",
        "range-separator": "至",
        "start-placeholder": "开始时间",
        "end-placeholder": "结束时间",
        "placeholder": "选择时间范围"
      },
      model: {
        value: (timeItem.timeRange),
        callback: function($$v) {
          _vm.$set(timeItem, "timeRange", $$v)
        },
        expression: "timeItem.timeRange"
      }
    })], 1)]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.delTimeList(timeItem, timeIndex)
        }
      }
    }, [_vm._v("删除")])], 1)])
  }) : _vm._e(), _vm._v(" "), (_vm.newGoods.postEnabled == true) ? _vm._l((_vm.newJobListForComm), function(jobComItem, jobComIndex) {
    return _c('div', {
      key: jobComIndex
    }, [_c('div', {
      staticClass: "left msgItem clearfix saleTimes",
      staticStyle: {
        "display": "flex"
      }
    }, [_c('span', {
      staticClass: "left itemName"
    }, [_vm._v("岗位：")]), _vm._v(" "), _c('div', {
      staticClass: "left timesBox clearfix"
    }, [_c('el-select', {
      staticClass: "itemSelect",
      staticStyle: {
        "width": "90%"
      },
      attrs: {
        "placeholder": "请选择岗位"
      },
      model: {
        value: (jobComItem.groupId),
        callback: function($$v) {
          _vm.$set(jobComItem, "groupId", $$v)
        },
        expression: "jobComItem.groupId"
      }
    }, _vm._l((_vm.jobTypeList), function(item) {
      return _c('el-option', {
        key: item.id,
        attrs: {
          "label": item.name,
          "value": item.id
        }
      })
    }), 1)], 1)]), _vm._v(" "), _c('div', {
      staticClass: "left msgItem clearfix",
      staticStyle: {
        "position": "relative"
      }
    }, [_c('span', {
      staticClass: "left itemName"
    }, [_c('i', [_vm._v("*")]), _vm._v("商品提成")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (jobComItem.commission),
        expression: "jobComItem.commission"
      }],
      staticClass: "left itemInput",
      staticStyle: {
        "width": "30%"
      },
      attrs: {
        "type": "text",
        "placeholder": "请输入提成",
        "maxlength": "6"
      },
      domProps: {
        "value": (jobComItem.commission)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(jobComItem, "commission", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "left",
      staticStyle: {
        "width": "30%"
      }
    }, [_vm._v("元"), _c('el-button', {
      staticStyle: {
        "padding-left": "5px"
      },
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.delJobComList(jobComItem, jobComIndex)
        }
      }
    }, [_vm._v("删除")])], 1)])])
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_vm._v("会员价")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": true
    },
    model: {
      value: (_vm.vipEnable),
      callback: function($$v) {
        _vm.vipEnable = $$v
      },
      expression: "vipEnable"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": false
    },
    model: {
      value: (_vm.vipEnable),
      callback: function($$v) {
        _vm.vipEnable = $$v
      },
      expression: "vipEnable"
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), (_vm.vipEnable) ? _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("会员价格")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vipPrice),
      expression: "vipPrice"
    }],
    staticClass: "left itemInput",
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入会员价格",
      "maxlength": "6"
    },
    domProps: {
      "value": (_vm.vipPrice)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.vipPrice = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "left",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("元")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_vm._v("展示在呼叫端")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": true
    },
    model: {
      value: (_vm.newGoods.salesEnabled),
      callback: function($$v) {
        _vm.$set(_vm.newGoods, "salesEnabled", $$v)
      },
      expression: "newGoods.salesEnabled"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": false
    },
    model: {
      value: (_vm.newGoods.salesEnabled),
      callback: function($$v) {
        _vm.$set(_vm.newGoods, "salesEnabled", $$v)
      },
      expression: "newGoods.salesEnabled"
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), (_vm.newGoods.salesEnabled) ? _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("展示销售数量")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": true
    },
    model: {
      value: (_vm.newGoods.salesShowEnabled),
      callback: function($$v) {
        _vm.$set(_vm.newGoods, "salesShowEnabled", $$v)
      },
      expression: "newGoods.salesShowEnabled"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": false
    },
    model: {
      value: (_vm.newGoods.salesShowEnabled),
      callback: function($$v) {
        _vm.$set(_vm.newGoods, "salesShowEnabled", $$v)
      },
      expression: "newGoods.salesShowEnabled"
    }
  }, [_vm._v("否")])], 1) : _vm._e(), _vm._v(" "), (_vm.newGoods.salesEnabled && _vm.newGoods.salesShowEnabled) ? _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("基础销售数量")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newGoods.salesCount),
      expression: "newGoods.salesCount"
    }],
    staticClass: "left itemInput",
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "type": "text",
      "placeholder": "",
      "maxlength": "6"
    },
    domProps: {
      "value": (_vm.newGoods.salesCount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newGoods, "salesCount", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_vm._v("显示在客户端")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": true
    },
    model: {
      value: (_vm.pcEnable),
      callback: function($$v) {
        _vm.pcEnable = $$v
      },
      expression: "pcEnable"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": false
    },
    model: {
      value: (_vm.pcEnable),
      callback: function($$v) {
        _vm.pcEnable = $$v
      },
      expression: "pcEnable"
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_vm._v("客户端允许购买")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": true
    },
    model: {
      value: (_vm.pcBuyEnable),
      callback: function($$v) {
        _vm.pcBuyEnable = $$v
      },
      expression: "pcBuyEnable"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": false
    },
    model: {
      value: (_vm.pcBuyEnable),
      callback: function($$v) {
        _vm.pcBuyEnable = $$v
      },
      expression: "pcBuyEnable"
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_vm._v("开启折扣")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": true
    },
    model: {
      value: (_vm.discountEnable),
      callback: function($$v) {
        _vm.discountEnable = $$v
      },
      expression: "discountEnable"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": false
    },
    model: {
      value: (_vm.discountEnable),
      callback: function($$v) {
        _vm.discountEnable = $$v
      },
      expression: "discountEnable"
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), (_vm.discountEnable) ? _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("折扣百分比")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discountPrice),
      expression: "discountPrice"
    }],
    staticClass: "left itemInput",
    staticStyle: {
      "width": "10%"
    },
    attrs: {
      "type": "text",
      "placeholder": "折扣",
      "maxlength": "6"
    },
    domProps: {
      "value": (_vm.discountPrice)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discountPrice = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "left",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("%")])]) : _vm._e(), _vm._v(" "), (_vm.discountEnable) ? _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName",
    staticStyle: {
      "width": "35%"
    }
  }, [_vm._v("折扣后商品提成")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.disCom),
      expression: "disCom"
    }],
    staticClass: "left itemInput",
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "type": "text",
      "placeholder": "提成",
      "maxlength": "6"
    },
    domProps: {
      "value": (_vm.disCom)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.disCom = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "left",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("元")])]) : _vm._e(), _vm._v(" "), (_vm.discountEnable) ? _c('div', {
    staticClass: "left msgItem clearfix",
    staticStyle: {
      "width": "100%",
      "min-height": "32px"
    }
  }, [_c('span', {
    staticClass: "left itemName",
    staticStyle: {
      "width": "20%"
    }
  }, [_c('i', [_vm._v("*")]), _vm._v("折扣星期选择")]), _vm._v(" "), _c('div', [_c('el-checkbox', {
    on: {
      "change": _vm.handleChangeWeeksAll
    },
    model: {
      value: (_vm.isAllWeek),
      callback: function($$v) {
        _vm.isAllWeek = $$v
      },
      expression: "isAllWeek"
    }
  }, [_vm._v("全选")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.discountEnable) ? _c('div', {
    staticClass: "left msgItem clearfix",
    staticStyle: {
      "width": "100%",
      "min-height": "32px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "10%"
    }
  }, [_c('el-checkbox-group', {
    on: {
      "change": _vm.handleChangeWeeks
    },
    model: {
      value: (_vm.newGoods.week),
      callback: function($$v) {
        _vm.$set(_vm.newGoods, "week", $$v)
      },
      expression: "newGoods.week"
    }
  }, _vm._l((_vm.weeks), function(weekItem) {
    return _c('el-checkbox', {
      key: weekItem,
      attrs: {
        "label": weekItem
      }
    }, [_vm._v(_vm._s(weekItem))])
  }), 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.discountEnable) ? _c('div', {
    staticClass: "left msgItem clearfix",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "font-size": "1rem",
      "text-align": "right",
      "width": "16.79%"
    }
  }, [_c('i', {
    staticStyle: {
      "color": "#d65252"
    }
  }, [_vm._v("*")]), _vm._v("折扣时间")]), _vm._v(" "), _c('el-time-picker', {
    attrs: {
      "placeholder": "起始时间"
    },
    model: {
      value: (_vm.beginTime),
      callback: function($$v) {
        _vm.beginTime = $$v
      },
      expression: "beginTime"
    }
  }), _vm._v(" "), _c('el-time-picker', {
    attrs: {
      "arrow-control": "",
      "placeholder": "截止时间"
    },
    model: {
      value: (_vm.endTime),
      callback: function($$v) {
        _vm.endTime = $$v
      },
      expression: "endTime"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix saleTimes"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_vm._v("销售时间")]), _vm._v(" "), _c('div', {
    staticClass: "left timesBox clearfix"
  }, [_c('div', {
    staticClass: "left addTimeBox",
    class: {
      addTimeBoxChoiced: _vm.timeChoiceBtn
    },
    on: {
      "click": _vm.addTimes
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v("添加\n                        ")]), _vm._v(" "), (!_vm.timeChoiceBtn && !_vm.newTimeList.length) ? _c('span', {
    staticClass: "allDay"
  }, [_vm._v("默认全天")]) : _vm._e(), _vm._v(" "), (_vm.timeChoiceBtn) ? _c('span', {
    staticClass: "itemSelect left"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "选择时间段"
    },
    model: {
      value: (_vm.timeChoice),
      callback: function($$v) {
        _vm.timeChoice = $$v
      },
      expression: "timeChoice"
    }
  }, _vm._l((_vm.timeList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": (item.beginHour < 10 ? '0' + item.beginHour : item.beginHour) + ':' +
          (item.beginMinute < 10 ? '0' + item.beginMinute : item.beginMinute) + '~' +
          (item.endHour < 10 ? '0' + item.endHour : item.endHour) + ':' +
          (item.endMinute < 10 ? '0' + item.endMinute : item.endMinute),
        "value": item.id
      }
    })
  }), 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "position": "absolute",
      "top": "-12px",
      "right": "-6px",
      "cursor": "pointer",
      "color": "red"
    },
    on: {
      "click": function($event) {
        _vm.timeChoiceBtn = false;
      }
    }
  }, [_vm._v("×")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "timesInner",
    attrs: {
      "id": "timeSales"
    }
  }, _vm._l((_vm.newTimeList), function(oitem) {
    return _c('div', {
      staticClass: "timesInnerItem clearfix"
    }, [_c('p', {
      staticClass: "left timeText",
      domProps: {
        "textContent": _vm._s((oitem.beginHour < 10 ? '0' + oitem.beginHour : oitem.beginHour) + ':' +
          (oitem.beginMinute < 10 ? '0' + oitem.beginMinute : oitem.beginMinute) + '~' +
          (oitem.endHour < 10 ? '0' + oitem.endHour : oitem.endHour) + ':' +
          (oitem.endMinute < 10 ? '0' + oitem.endMinute : oitem.endMinute) + '(' + oitem.name + ')')
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "removeBtn right",
      on: {
        "click": function($event) {
          return _vm.removeTimes(oitem)
        }
      }
    }, [_vm._v("×")])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "left img_box clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("商品图片")]), _vm._v(" "), _c('div', {
    staticClass: "left img"
  }, [_c('div', {
    staticClass: "img_item left"
  }, [(_vm.newGoods.imageURL) ? _c('img', {
    ref: "goodsImg",
    attrs: {
      "src": _vm.newGoods.imageURL + '?x-oss-process=image/resize,l_300',
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.newGoods.imageURL) ? _c('span', {
    staticClass: "del-img",
    on: {
      "click": _vm.delImg
    }
  }, [_vm._v("X")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "img_up_btn left"
  }, [_c('i', {
    staticClass: "iconfont icon-xiazai"
  }), _vm._v(" "), _c('input', {
    staticClass: "pcImgFile",
    attrs: {
      "type": "file",
      "accept": ".png,.jpg,.jpeg",
      "title": "选择图片"
    },
    on: {
      "change": _vm.coverImg
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "mobileImgFile",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.coverImg
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "uploadImgTip"
  }, [_vm._v("\n                            支持JPG、JPEG、PNG格式，单张大小不超过5M，建议尺寸 600*600 px\n                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "left mat-goods"
  }, [_c('span', {
    staticClass: "tit"
  }, [_vm._v("商品规格:")]), _vm._v(" "), _c('span', {
    staticClass: "seled-mat-list"
  }, _vm._l((_vm.seledSpec), function(tag) {
    return _c('el-tag', {
      key: tag.name,
      attrs: {
        "closable": ""
      },
      on: {
        "close": function($event) {
          return _vm.closeSpec(tag)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(tag.name) + "\n                        ")])
  }), 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.addSpec
    }
  }, [_vm._v("+添加")])], 1), _vm._v(" "), _c('div', {
    staticClass: "left mat-goods"
  }, [_c('span', {
    staticClass: "tit"
  }, [_vm._v("包含原料:")]), _vm._v(" "), _c('span', {
    staticClass: "seled-mat-list"
  }, _vm._l((_vm.seledMats), function(tag) {
    return _c('el-tag', {
      key: tag.name
    }, [_vm._v("\n                        " + _vm._s(tag.name) + "*" + _vm._s(tag.count) + "\n                        ")])
  }), 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.addMatGoods
    }
  }, [_vm._v("+添加")])], 1), _vm._v(" "), _c('div', {
    staticClass: "left mat-goods"
  }, [_c('span', {
    staticClass: "tit"
  }, [_vm._v("配品:")]), _vm._v(" "), _c('span', {
    staticClass: "seled-mat-list"
  }, _vm._l((_vm.seledPeiGoods), function(tag) {
    return _c('el-tag', {
      key: tag.name,
      attrs: {
        "closable": ""
      },
      on: {
        "close": function($event) {
          return _vm.closePei(tag)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(tag.name) + "\n                        ")])
  }), 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.addPeiGoods
    }
  }, [_vm._v("+添加")])], 1)], 2)]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "save",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.beforeUpGoods
    }
  }, [_vm._v("保存")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "同步商品",
      "show-close": false,
      "before-close": _vm.cancelTb,
      "visible": _vm.shareGoods,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.shareGoods = $event
      }
    }
  }, [_c('el-form', {
    staticStyle: {
      "width": "100%",
      "display": "flex",
      "justify-content": "center"
    },
    attrs: {
      "label-position": 'top',
      "label-width": "80px"
    }
  }, [_c('el-form-item', [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("请选择需要将此商品同步到的店铺")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "450px"
    },
    attrs: {
      "multiple": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.tbForm.storeIds),
      callback: function($$v) {
        _vm.$set(_vm.tbForm, "storeIds", $$v)
      },
      expression: "tbForm.storeIds"
    }
  }, _vm._l((_vm.storeList), function(item) {
    return (item.id != _vm.curStoreId) ? _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    }) : _vm._e()
  }), 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelTb
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "save",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.doUpGoods
    }
  }, [_vm._v("保存")])])], 1), _vm._v(" "), (_vm.showCrop) ? _c('img-crop', {
    attrs: {
      "oldImg": _vm.oldImgBase64,
      "curCropW": _vm.curCropW,
      "curCropH": _vm.curCropH,
      "curStoreId": _vm.curStoreId
    },
    on: {
      "closeImgCrop": function($event) {
        _vm.showCrop = false
      },
      "getCropImgBase": _vm.getCropImgBase
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showMat) ? _c('selGoods', {
    attrs: {
      "seledGoods": _vm.seledMats,
      "storeId": _vm.curStoreId
    },
    on: {
      "selOk": _vm.selOk,
      "closeSelGoods": function($event) {
        _vm.showMat = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showPei) ? _c('selPeiGoods', {
    attrs: {
      "seledGoods": _vm.seledPeiGoods,
      "storeId": _vm.curStoreId
    },
    on: {
      "selOk": _vm.selOkForPei,
      "closeSelGoods": function($event) {
        _vm.showPei = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showSpec) ? _c('selSpec', {
    attrs: {
      "seledGoods": _vm.seledSpec,
      "storeId": _vm.curStoreId
    },
    on: {
      "selOk": _vm.selOkForSpec,
      "closeSelGoods": function($event) {
        _vm.showSpec = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "titleTable"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "4%"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "8%"
    }
  }, [_vm._v("商品")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("商品名")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "8%"
    }
  }, [_vm._v("分类")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v("排序值")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "6%"
    }
  }, [_vm._v("销售价")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "11%"
    }
  }, [_vm._v("销售时间段")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "11%"
    }
  }, [_vm._v("折扣时间段")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "6%"
    }
  }, [_vm._v("会员价")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "4%"
    }
  }, [_vm._v("折扣价")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v("厨房打印")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v("标签打印")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v("管理库存")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "12%"
    }
  }, [_vm._v("操作")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-2d0534b4","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/indexRouters/goods/info.vue
// module id = 933
// module chunks = 1